import { render, staticRenderFns } from "./SupportAdmin.vue?vue&type=template&id=1d108ad4&scoped=true&"
import script from "./SupportAdmin.vue?vue&type=script&lang=js&"
export * from "./SupportAdmin.vue?vue&type=script&lang=js&"
import style0 from "./SupportAdmin.vue?vue&type=style&index=0&id=1d108ad4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d108ad4",
  null
  
)

export default component.exports